module.exports = __webpack_public_path__ + "media/images/okra-offers/discover-area-img-790182f7dde15fb8da0d09c44ba925a9.png";